import { plannerEventTypes } from '@constants/schedule';
import QuizCard from './PlannerCards/QuizCard/QuizCard';
import TestCard from './PlannerCards/TestCard/TestCard';
import LMPCard from './PlannerCards/LMPCard/LMPCard';
import ClassCard from './PlannerCards/ClassCard/ClassCard';
import { plannerItemTypes } from './planner-constants';
import DayTitle from './PlannerCards/DayTitle';
import GreetingCard from './PlannerCards/GreetingCard';
import SubscriptionFeedbackCard from './PlannerCards/SubscriptionFeedbackCard/SubscriptionFeedbackCard';
import SubscriptionRenewalCard from './PlannerCards/SubscriptionRenewalCard/SubscriptionRenewalCard';
import FeatureCard from './PlannerCards/FeatureCard/FeatureCard';
import SubscriptionFeedbackCardV2 from './PlannerCards/SubscriptionFeedbackCard/SubscriptionFeedbackCardV2';
import FreeTrialCard from './PlannerCards/FreeTrial';
import { DefaultLoaderSkeleton } from './PlannerCards/PlannerElements';
import NoSessionCard from './PlannerCards/NoSessionCard';

const eventTypeComponentMap = {
  [plannerEventTypes.QUIZ]: QuizCard,
  [plannerEventTypes.TEST]: TestCard,
  [plannerEventTypes.TEST_WITH_EDUCATOR]: TestCard,
  [plannerEventTypes.LIVE_INTERACTION]: LMPCard,
  [plannerEventTypes.CLASS]: ClassCard,
  [plannerEventTypes.CLASS_WITH_PRACTICE]: ClassCard,
  [plannerEventTypes.OFFLINE_TEST]: TestCard
};

const plannerItemTypeComponentMap = {
  [plannerItemTypes.DAY_TITLE]: DayTitle,
  [plannerItemTypes.GREETING]: GreetingCard,
  [plannerItemTypes.BROWSE]: NoSessionCard,
  [plannerItemTypes.SUBSCRIPTION_FEEDBACK]: SubscriptionFeedbackCard,
  [plannerItemTypes.SUBSCRIPTION_RENEWAL]: SubscriptionRenewalCard,
  [plannerItemTypes.FEATURE_INTRODUCTION]: FeatureCard,
  [plannerItemTypes.FEATURE_AWARENESS]: FeatureCard,
  [plannerItemTypes.SUBSCRIPTION_FEEDBACK_V2]: SubscriptionFeedbackCardV2,
  [plannerItemTypes.FREE_TRIAL_CARD]: FreeTrialCard,
  [plannerItemTypes.SKELETON_LOADER]: DefaultLoaderSkeleton,
  [plannerItemTypes.NO_SESSION_EVENTS]: NoSessionCard
};

const Row = ({ metaItem, eventsCount }) => {
  const { eventType, plannerItemType } = metaItem;
  const Card =
    eventTypeComponentMap[eventType] ||
    plannerItemTypeComponentMap[plannerItemType];
  if (Card) return <Card metaItem={metaItem} eventsCount={eventsCount} />;

  return null;
};

export default Row;
